import React from "react";
import { Layout, Select } from "antd";
import classes from "./HeaderContent.module.css";

const { Header } = Layout;
const { Option } = Select;

const HeaderContent = () => {
  return (
    <Header className={classes.header}>
      <div className={classes.headerTitle}>Absolute ERP</div>
      <div className={classes.headerRight}>
        <Select
          defaultValue="company1"
          style={{ width: 200 }}
          className={classes.dropdown}
        >
          <Option value="company1">Company 1</Option>
          <Option value="company2">Company 2</Option>
        </Select>
        
        <Select
          defaultValue="2024"
          style={{ width: 150 }}
          className={classes.dropdown}
        >
          <Option value="2024">FY 2024-25</Option>
          <Option value="2023">FY 2023-24</Option>
        </Select>

        <Select
          defaultValue="en"
          style={{ width: 100 }}
          className={classes.languageSelector}
        >
          <Option value="en">English</Option>
          <Option value="hi">Hindi</Option>
        </Select>
      </div>
    </Header>
  );
};

export default HeaderContent;
